import React from 'react';
import {Button, Stack, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {useBeneficiaryCard} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {SelectedPlanBarProps} from './types';

const {change} = translations['pt-br'].commons;
const {selectedPlan} = translations['pt-br'].others.selectionFlow;

export function SelectedPlanBar({handleChangeBeneficiary}: SelectedPlanBarProps) {
	const theme = useTheme();
	const {isMobile} = useMediaQueries();
	const {beneficiaryCardPlanData} = useBeneficiaryCard();

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="flex-start"
			gap={2}
			sx={{bgcolor: 'background.paper', px: isMobile ? 2 : 4, py: 2}}>
			<Stack direction="row" gap={1} alignItems="center">
				<Icon name="hapvida-logo" size={20} color={theme.palette.primary.main} />
				<Stack>
					<Typography variant="caption" color="text.secondary">
						{selectedPlan}
					</Typography>
					<Stack direction="row" flexWrap="wrap" gap={0.5} alignItems="baseline">
						<Typography variant="subtitle2" color="primary" fontWeight={600}>
							{beneficiaryCardPlanData?.planName}
						</Typography>
						<Typography variant="subtitle2" color="text.secondary" fontWeight={400}>
							({beneficiaryCardPlanData?.userName})
						</Typography>
					</Stack>
				</Stack>
			</Stack>
			<Button
				variant="text"
				onClick={handleChangeBeneficiary}
				data-tag-id={AutoSolEnum.AS_CLICK_ALTERAR_PLANO}
				sx={{padding: 0, minWidth: 0, textDecoration: 'underline'}}>
				{change}
			</Button>
		</Stack>
	);
}
